import React from 'react'

const Heading = ({data}) => {
  return (
    <div>
      <h1 className='font-bold uppercase text-3xl mb-1'>{data}</h1>
      <div class="h-[3px] bg-light-secondary w-[70px] "></div>
    </div>
  )
}

export default Heading
